import {useProjectId, useProjectUnitSystem} from "../ProjectName";
import {
    AdjustCol,
    makeSelectWrapper,
    NumberCol,
    RenderStringCol,
    SelectCol,
    StringCol,
    Table,
    ViewOnly
} from "../../../../misc/scroller/Table";
import {WoodDetailItem} from "../../../../api/Openings";
import {api} from "../../../../api/API";
import React, {useContext} from "react";
import {DropDownContext, useDropdownData} from "../../settings/DropDowns";
import {WoodDetailFilePopup} from "./WoodDetailFileAttachment";
import {useIsQuote} from "../../quote/QuoteContainer";
import {useAlternative} from "../../quote/alternative/Alternative";

export function WoodDetails() {
    const project = useProjectId();
    const sys = useProjectUnitSystem();
    const ddl = useContext(DropDownContext);

    const cutOptions = useDropdownData(ddl.doorMaterialWoodCut);
    const matchingOptions = useDropdownData(ddl.doorMaterialWoodMatching);
    const matchingMethodOptions = useDropdownData(ddl.doorMaterialWoodMatchingMethod);
    const finishOptions = useDropdownData(ddl.doorMaterialWoodFinish);
    const plyOptions = useDropdownData(ddl.doorMaterialWoodPly);
    const isQuote = useIsQuote();
    const alt = useAlternative();

    console.log(ddl.loading, plyOptions);

    if(!sys || ddl.loading) return null;

    return (
        <Table<WoodDetailItem>
            name={"wood-details"}
            fetch={async (ctx) => {
                if(isQuote) {
                    return api.quoteOpenings.listWoodDetails({
                        project: project,
                        alternative: alt,
                    })
                }

                return api.openings.listWoodDetails({
                    project: project,
                })
            }}
            fetchDeps={[project, alt, isQuote]}
            columns={[

                ViewOnly(StringCol("Material", "doorMaterial")),

                StringCol("Name", "doorWdMaterialName"),
                SelectCol<WoodDetailItem>("Cut", "doorWdCut", makeSelectWrapper(cutOptions)),
                SelectCol<WoodDetailItem>("Matching", "doorWdMatching", makeSelectWrapper(matchingOptions)),
                SelectCol<WoodDetailItem>("Matching Method", "doorWdMatchingMethod", makeSelectWrapper(matchingMethodOptions)),
                SelectCol<WoodDetailItem>("Ply", "doorWdPly", makeSelectWrapper(plyOptions)),
                SelectCol<WoodDetailItem>("Finish", "doorFinish", makeSelectWrapper(finishOptions)),
                StringCol("Color Ref", "doorWdSwatchName"),

                AdjustCol(StringCol<WoodDetailItem>("Attachment", "doorWdProofFileName"), {
                    editable: {
                        type: "custom",
                        render: props => <WoodDetailFilePopup {...props} />,
                        paste: (row: WoodDetailItem, value: string) => {
                            if(value) {
                                row.doorWdProofFile = parseInt(value);
                            } else {
                                row.doorWdProofFile = null;
                            }
                        },
                        copy: (v: WoodDetailItem) => {
                            return v.doorWdProofFile?.toString() || "";
                        }
                    }
                }),
                {
                    name: "Has Attachment",
                    width: 100,
                    render: data => {
                        return data.doorWdProofFile ? "Yes" : "No";
                    }
                },
                ViewOnly(NumberCol<WoodDetailItem>("Qty", "count")),
                RenderStringCol("-", () => ""),
            ]}
            columnDeps={[]}
            onChange={v => {
                if(isQuote) {
                    return api.quoteOpenings.updateWoodDetail(v);
                }

                return api.openings.updateWoodDetail(v);
            }}
        />
    )
}